import { createSelector } from 'reselect'
import { get, safeToJS } from 'utils/immutable'

const rulesUtilsState = (state) => state.get('rulesUtils')

const selectRulesUtilsData = createSelector(rulesUtilsState, get('data'))

export const getRulesUtilsData = createSelector(selectRulesUtilsData, safeToJS)

export const getIsRulesUtilsLoading = createSelector(
  rulesUtilsState,
  get('isLoading')
)

export const getHasRulesUtilsError = createSelector(
  rulesUtilsState,
  get('error')
)
